import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StyledSelection } from './Styles';

export const propTypes = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    testId: PropTypes.string,
    content: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.string,
      PropTypes.number
    ]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selected: PropTypes.bool,
    disabled: PropTypes.bool
  }),
  index: PropTypes.number,
  onClick: PropTypes.func
};

const defaultProps = {
  item: {},
  index: 0,
  onClick: undefined
};

const Item = ({ item, index, onClick, parentTestId }) => {
  const [isSelected, setIsSelected] = useState(false);
  const { content, label, id, testId, selected, disabled } = item;

  const handleClick = event => {
    event.preventDefault();
    event.persist();

    if (disabled) {
      return;
    }

    const nextSelected = selected === undefined ? !isSelected : !selected;
    if (onClick) {
      onClick(event, {
        ...item,
        selected: nextSelected
      });
    }

    if (selected === undefined) {
      setIsSelected(nextSelected);
    }
  };

  if (!content && !label) return null;
  return (
    <StyledSelection
      key={id || index || null}
      data-testid={testId || `${parentTestId}-item`}
      onClick={onClick ? handleClick : undefined}
      selected={selected !== undefined ? Boolean(selected) : isSelected}
      disabled={disabled}
    >
      {content || label}
    </StyledSelection>
  );
};

Item.propTypes = propTypes;
Item.defaultProps = defaultProps;

export default Item;
